<template>
  <div v-if="blok" :class="marginClasses">
    <SFHeadline v-if="blok.fields.h1 ?? ''" tag="h1" is-uppercase>
      {{ blok.fields.h1 }}
    </SFHeadline>
    <Swiper
      v-if="blok?.fields.slides?.length ?? 0"
      ref="sliderRef"
      loop
      :navigation="{
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev',
      }"
      :modules="[SwiperAutoplay, SwiperNavigation, SwiperPagination]"
      :autoplay="{ delay: 8000, disableOnInteraction: false }"
      :pagination="{ clickable: true }"
      :wrapper-class="isDark ? 'dark-mode' : ''"
      class="relative"
    >
      <button class="swiper-prev" aria-label="prev-slide">
        <IconChevronLeft class="size-6" />
      </button>

      <button class="swiper-next" aria-label="next-slide">
        <IconChevronRight class="size-6" />
      </button>

      <SwiperSlide
        v-for="(slide, index) in filteredSlides"
        :key="`cms-slide-${slide?.sys?.id}`"
      >
        <CMSSlide v-if="slide" :blok="slide" :preload="index === 0" />
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import {
  Autoplay as SwiperAutoplay,
  Navigation as SwiperNavigation,
  Pagination as SwiperPagination,
} from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useContentfulMargins } from '../composables/useContentfulMargins'
import type { CMSSlideShowProps } from '../types'
import CMSSlide from './Slide.vue'
import { SFHeadline } from '#storefront-ui/components'

const { blok } = defineProps<CMSSlideShowProps>()

const sliderRef = ref()

const isDark = ref(true)

const { marginClasses } = useContentfulMargins(blok?.fields.marginTop)

const filteredSlides = computed(() => {
  return blok?.fields?.slides?.filter((slide) => !!slide?.fields?.uid)
})

defineOptions({ name: 'CMSSlideShow' })
</script>

<style scoped>
.swiper-next,
.swiper-prev {
  @apply h-11 w-11 bg-white absolute top-1/2  -translate-y-1/2 z-10 rounded-full md:flex justify-center items-center hidden;
}
.swiper-prev {
  @apply left-6;
}
.swiper-next {
  @apply right-6;
}
.swiper-pagination-bullet {
  @apply w-[60px] h-[4px] bg-white rounded-none opacity-100;
}
.swiper-pagination-bullet-active {
  @apply bg-gray-600;
}

:deep(.swiper-button-lock) {
  @apply hidden;
}
</style>
